<mat-toolbar class="main-footer">
    <div class="footer-left">
        Copyright &copy; 2026 <span class="bullet"></span> Powered By <a href="https://einfosoft.com/"
            target="_blank">Agitex</a>
    </div>
</mat-toolbar>